import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as addressActions from '../../../actions/addressActions';
import OrderModalStep from '../OrderModalStep/OrderModalStep';
import AddressForm from './AddressForm';
import AddressMap from './AddressMap';
import {PHONE_REGEX} from '../../../constants/formats';
import './AddressStep.less';

class AddressStep extends React.Component {
  constructor(props) {
    super(props);
    this.handleAddressChange = this.handleAddressChange.bind(this);
    this.validate = this.validate.bind(this);
    this.state = {
      validityMap: {},
      validationRun: 0
    };
  }

  handleAddressChange(address) {
    const {addressActions} = this.props;
    addressActions.setAddress(address);
  }

  validate() {
    const {address} = this.props;

    const validityMap = {
      streetAddress: !!address.streetAddress,
      phone: PHONE_REGEX.test(address.phone),
      piAgreed: address.piAgreed
    };

    const hasInvalid = Object.keys(validityMap).some(key => !validityMap[key]);
    const validationRun = hasInvalid ? this.state.validationRun + 1 : 0;

    this.setState({validationRun, validityMap});

    return !hasInvalid;
  }

  render () {
    const {handleAddressChange, validate} = this;
    const {address, onPrimaryAction, onBack, onClose} = this.props;
    const {validationRun, validityMap} = this.state;

    return (
      <OrderModalStep className="address-step"
        title="Dla dostawcy"
        primaryActionTitle="Dalej >>"
        onPrimaryAction={() => {validate() && onPrimaryAction();}}
        onBack={onBack}
        onClose={onClose}>
        <AddressForm address={address} onChange={handleAddressChange} validationRun={validationRun} validityMap={validityMap} addressMap={
          <aside>
            <AddressMap address={address} />
          </aside>
        } />
      </OrderModalStep>
    );
  }
}

AddressStep.propTypes = {
  onPrimaryAction: PropTypes.func,
  onBack: PropTypes.func,
  onClose: PropTypes.func,
  address: PropTypes.object.isRequired,
  addressActions: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    address: state.address
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addressActions: bindActionCreators(addressActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddressStep);



// WEBPACK FOOTER //
// ./src/components/OrderModal/AddressStep/AddressStep.js